import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthProvider } from "../../firebase/auth/auth.provider";

/**
 * Interceptor to add Authorization header to requests sent to our cloud functions server.
 * This is a necessary step since our cloud functions validates the client on request.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(public auth: AuthProvider) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if(req.url.startsWith('https://us-central1-unity-e.cloudfunctions.net')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${window.sessionStorage.getItem('edu-currentUser-token')}`
        }
      });
    }
    return next.handle(req);
  }
}
